export const handleAnimationComplete = () => {
    const element = document.querySelector(".hero") as HTMLElement;
    if (element) {
      element.style.zIndex = "2";
    }
    console.log("Animation complete");
  };